import $i18n from '@alife/panda-i18n';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { CnDialog, CnMessage, CnAsyncSelect, Form, Field, CnNumberPicker, } from '@alife/cn-ui';
import { alterSelfVasItems, createSelfVasItems } from '../../api';
const FormItem = Form.Item;
/**
 *  交货单--增值服务
 */
export default function AddForm(props) {
    const { editorRecord = {}, addDialogMode, setAddDialogMode, serviceList, existedServiceType, asnCode, handleSearch, newServiceExtraData, } = props;
    const field = Field.useField();
    const { reset } = field;
    const [loading, setLoading] = useState(false);
    const [serviceSelData, setServiceSelData] = useState({});
    // 处理服务项数据 - 新增/编辑 - 去除已增加过的项
    const serviceListNew = useMemo(() => {
        return serviceList.filter((one) => one.value === editorRecord?.selfVasType ||
            !existedServiceType?.includes(one.value));
    }, [editorRecord, serviceList, existedServiceType]);
    // 服务项 - 选择 - 获取到可操作可编辑项 - showItem/requiredItem
    const serviceChange = useCallback((v = 1, isReset = 1, editData = {}) => {
        const selService = (serviceList &&
            serviceList.find((item) => {
                return item?.value === v;
            })) ||
            {};
        setServiceSelData(selService);
        reset();
        field.setValue('valueAddedServiceType', v);
        if (isReset) {
            // 服务项 - 选择时切换 - 清空输入内容
            field.setValues({
                selfValueaddNum: undefined,
                selfValueaddVolume: undefined,
                selfValueaddWeight: undefined,
            });
        }
        else {
            reset();
            // 编辑时 - 初始化数据
            field.setValues(editData);
        }
    }, [field, reset, serviceList]);
    // 服务 - 保存
    const handleSave = useCallback(() => {
        field.validate((error, value) => {
            if (error) {
                return;
            }
            setLoading(true);
            const { valueAddedServiceType, selfValueaddNum, selfValueaddVolume, selfValueaddWeight, } = value;
            const tmpParams = {
                asnCode,
                valueAddedServiceType,
                selfValueaddNum,
                selfValueaddVolume,
                selfValueaddWeight,
            };
            if (addDialogMode === 'edit') {
                tmpParams.vasId = editorRecord?.id;
            }
            if (addDialogMode === 'new') {
                tmpParams.accountType =
                    newServiceExtraData?.vasSelfPayerInfo?.vasSelfAccountType?.toString() ||
                        '';
            }
            const request = addDialogMode === 'new'
                ? createSelfVasItems(tmpParams)
                : alterSelfVasItems(tmpParams);
            request
                .then(() => {
                setLoading(false);
                setServiceSelData(null);
                CnMessage.success($i18n.get({ id: '', dm: '新增服务成功' }));
                setAddDialogMode(null);
                handleSearch();
            })
                .catch((err) => {
                setLoading(false);
                CnMessage.error(err?.message);
                setAddDialogMode(null);
            });
        });
    }, [
        addDialogMode,
        asnCode,
        editorRecord?.id,
        field,
        setAddDialogMode,
        handleSearch,
    ]);
    const onClose = useCallback(() => {
        setServiceSelData(null);
        setAddDialogMode(null);
    }, []);
    // 控制编辑框 - 是否显示 / 是否可编辑 / 是否必填
    const isEdit = useCallback((type = 'showItem', name = 'cnSelfVasNum') => {
        return serviceSelData?.[type]?.includes(name);
    }, [serviceSelData]);
    const init = useCallback(() => {
        if (addDialogMode === 'edit' && editorRecord) {
            const { selfVasType = 1, selfVasNum = undefined, selfVasVolume = undefined, selfVasWeight = undefined, } = editorRecord;
            serviceChange(selfVasType, 0, {
                valueAddedServiceType: selfVasType,
                selfValueaddNum: selfVasNum,
                selfValueaddVolume: selfVasVolume,
                selfValueaddWeight: selfVasWeight,
            });
        }
    }, [addDialogMode, editorRecord, serviceChange]);
    useEffect(() => {
        init();
    }, [init]);
    return (React.createElement(CnDialog, { size: 'medium', className: 'asn-add-service', title: addDialogMode === 'new'
            ? $i18n.get({ id: 'NewService', dm: '新增服务' })
            : $i18n.get({ id: 'EditingService', dm: '编辑服务' }), visible: !!addDialogMode, onClose: onClose, onCancel: onClose, onOk: handleSave, okProps: { loading, disabled: loading } },
        React.createElement(React.Fragment, null,
            React.createElement(Form, { field: field },
                React.createElement(FormItem, { label: $i18n.get({ id: 'ServiceItem', dm: '服务项' }), name: 'valueAddedServiceType', required: true, requiredMessage: $i18n.get({
                        id: 'PleaseSelectAServiceItem',
                        dm: '请选择服务项',
                    }) },
                    React.createElement(CnAsyncSelect, { showSearch: true, hasClear: true, dataSource: serviceListNew, style: { width: '100%' }, onChange: (v) => serviceChange(v) })),
                isEdit('showItem', 'cnSelfVasNum') && (React.createElement(FormItem, { label: $i18n.get({ id: 'TotalQuantityPieces', dm: '总数量(件)' }), name: 'selfValueaddNum', required: !isEdit('disabledItem', 'cnSelfVasNum'), requiredMessage: $i18n.get({
                        id: 'PleaseEnterTheTotalQuantityPieces_1870704616',
                        dm: '请输入总数量(件)',
                    }) },
                    React.createElement(CnNumberPicker, { disabled: isEdit('disabledItem', 'cnSelfVasNum'), precision: 0, min: 0, style: { width: '100%' } }))),
                isEdit('showItem', 'cnSelfVasVolume') && (React.createElement(FormItem, { label: $i18n.get({ id: 'TotalVolumeM', dm: '总体积(立方米)' }), name: 'selfValueaddVolume', required: !isEdit('disabledItem', 'cnSelfVasVolume'), requiredMessage: $i18n.get({
                        id: 'PleaseEnterTheTotalVolumeCubic_1622476478',
                        dm: '请输入总体积(立方米)',
                    }) },
                    React.createElement(CnNumberPicker, { disabled: isEdit('disabledItem', 'cnSelfVasVolume'), precision: 2, min: 0, style: { width: '100%' } }))),
                isEdit('showItem', 'cnSelfVasWeight') && (React.createElement(FormItem, { label: $i18n.get({ id: 'TotalWeightKg', dm: '总重量(千克)' }), name: 'selfValueaddWeight', required: !isEdit('disabledItem', 'cnSelfVasWeight'), requiredMessage: $i18n.get({
                        id: 'PleaseEnterTheTotalWeightKg_1560294052',
                        dm: '请输入总重量(千克)',
                    }) },
                    React.createElement(CnNumberPicker, { disabled: isEdit('disabledItem', 'cnSelfVasWeight'), precision: 2, min: 0, style: { width: '100%' } })))))));
}
